import { IconButton } from '../../iconButton';
import { Button } from '../../buttons/button';
import { Icon as IconComponent } from '@doxyme/icons';
import Box from '@mui/material/Box';
import { useIntl } from '@doxyme/locale';

import type { JSX } from 'react';

export enum NotificationCancelButtonType {
  Icon = 'closeIcon',
  Text = 'cancelText',
}

type Props = {
  notificationId: string;
  type: NotificationCancelButtonType;
  dismissNotification: (id: string) => void;
};

export const NotificationCancelButton = ({
  notificationId,
  type,
  dismissNotification,
}: Props): JSX.Element => {
  const { formatMessage } = useIntl();

  return (
    <>
      {type === NotificationCancelButtonType.Icon && (
        <Box
          sx={{
            display: 'flex',
            alignSelf: 'flex-start',
          }}
        >
          <IconButton
            type='subtle'
            size='small'
            icon={<IconComponent.Close size='xsmall' />}
            onClick={() => dismissNotification(notificationId)}
            title={formatMessage({ id: 'notification.cancelButtonTooltip' })}
          />
        </Box>
      )}
      {type === NotificationCancelButtonType.Text && (
        <Box
          sx={{
            display: 'flex',
            alignSelf: 'flex-start',
          }}
        >
          <Button
            type='secondary'
            size='xsmall'
            onClick={() => dismissNotification(notificationId)}
          >
            {formatMessage({ id: 'notification.cancelButton' })}
          </Button>
        </Box>
      )}
    </>
  );
};
